'use client';

import { useEffect, useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function AboutHeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative w-full min-h-[70vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-secondary via-secondary/95 to-primary/20 pt-32 pb-20 px-6">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      {/* Floating Icons */}
      <div className="absolute inset-0 pointer-events-none">
        <Icon name="AcademicCapIcon" size={60} className="absolute top-20 left-10 text-primary/20 animate-pulse delay-100" />
        <Icon name="UserGroupIcon" size={50} className="absolute top-40 right-20 text-primary/20 animate-pulse delay-300" />
        <Icon name="LightBulbIcon" size={70} className="absolute bottom-32 left-20 text-primary/20 animate-pulse delay-500" />
        <Icon name="TrophyIcon" size={55} className="absolute bottom-20 right-32 text-primary/20 animate-pulse delay-700" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center">
        {/* Badge */}
        <div
          className={`inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 py-2 mb-8 ${
            isVisible ? 'animate-fadeInUp delay-100' : 'opacity-0'
          }`}
        >
          <Icon name="SparklesIcon" size={16} className="text-primary" />
          <span className="text-xs font-semibold uppercase tracking-wider text-white">
            About Apollobits Academy
          </span>
        </div>

        {/* Main Heading */}
        <h1
          className={`font-display text-6xl md:text-8xl uppercase tracking-tighter leading-none text-white mb-6 ${
            isVisible ? 'animate-slideInBlur delay-200' : 'opacity-0'
          }`}
        >
          Empowering<br />
          <span className="text-primary">Learners</span> Since<br />
          2020
        </h1>

        {/* Subheadline */}
        <p
          className={`text-lg md:text-xl text-white/80 max-w-3xl mx-auto leading-relaxed ${
            isVisible ? 'animate-fadeInUp delay-400' : 'opacity-0'
          }`}
        >
          Bridging the gap between education and industry with practical training, expert mentorship, and real-world experience.
        </p>
      </div>
    </section>
  );
}